import { lookupRendererEntry } from './LookupRenderer';
import { treeLookupRendererEntry } from './TreeLookupRenderer';
import { enumRendererEntry } from './EnumRenderer';
import { gridLayoutRendererEntry } from './GridLayoutRenderer';
import { gridGroupRendererEntry } from './GridGroupRenderer';
import { dateRendererEntry } from './DateRenderer';
import { dateTimeRendererEntry } from './DateTimeRenderer';
import { conditionEditorRendererEntry } from './ConditionEditorRenderer';
import { triggerEditorRendererEntry } from './TriggerEditorRenderer';
import { actionsEditorRendererEntry } from './ActionsEditorRenderer';
import {
  tooltipTextRendererEntry,
  tooltipNumberRendererEntry,
  tooltipIntegerRendererEntry,
} from './TooltipMaterialRenderers';
import { staticEnumRendererEntry } from './StaticEnumRenderer';
import { hierarchyRefRendererEntry } from './HierarchyRefRenderer';
import { entityBackedRowConfigEntry } from './EntityBackedRowConfigRenderer';
import { rowSourceDimensionFieldEntry } from './RowSourceDimensionFieldRenderer';
import { rowAxisFilterEntry } from './RowAxisFilterRenderer';
import { accountFilterEntry } from './AccountFilterRenderer';
import { dimensionSetEditorEntry } from './DimensionSetEditor';
import { principalRendererEntry } from './PrincipalRenderer';
import { pathPreviewRendererEntry } from './PathPreviewRenderer';
import { inheritedLookupEntry } from './InheritedLookupControl';
import { ruleModulePickerEntry, ruleEntityPickerEntry } from './RuleScopeRenderers';
import { computedDefaultRendererEntry } from './ComputedDefaultControl';

/**
 * Custom JSON Forms renderers
 *
 * These renderers extend JSON Forms with custom UI components
 * for specific field types and patterns.
 */
export const customRenderers = [
  // Business rule editors (high priority)
  conditionEditorRendererEntry,
  triggerEditorRendererEntry,
  actionsEditorRendererEntry,
  ruleModulePickerEntry,
  ruleEntityPickerEntry,
  // Standard renderers
  lookupRendererEntry,
  // Entity lookups with a grayed nearest-ancestor inherited value (x-inherit — priority 15)
  inheritedLookupEntry,
  // Tree-presented entity lookups (lookup.presentation: tree — priority 12, above LookupRenderer)
  treeLookupRendererEntry,
  enumRendererEntry,
  gridLayoutRendererEntry,
  gridGroupRendererEntry,
  dateRendererEntry,
  dateTimeRendererEntry,
  // Tooltip-enhanced renderers for plain text/number fields (priority 3)
  tooltipTextRendererEntry,
  tooltipNumberRendererEntry,
  tooltipIntegerRendererEntry,
  // Static enum renderer with tooltip support (priority 3)
  staticEnumRendererEntry,
  // Hierarchy tree picker for HierarchyRef fields (priority 10)
  hierarchyRefRendererEntry,
  // Path fragment with its full resolved location shown underneath (priority 10)
  pathPreviewRendererEntry,
  // Gate PlanViewRowDimension row-enumeration config to entity-backed dimensions only (priority 25)
  entityBackedRowConfigEntry,
  // Gate PlanViewRowDimension dimensionDefinitionId to a DIMENSION row source; hide + clear for ACCOUNT (priority 25)
  rowSourceDimensionFieldEntry,
  // Embedded condition editor for a PlanViewRowDimension filterJson (priority 20; the gate above
  // delegates filterJson here for entity-backed dimensions)
  rowAxisFilterEntry,
  // Condition editor for a PlanStatementRow account filter (priority 20)
  accountFilterEntry,
  // Inline dimension-values editor for DimensionSet carrier FKs (priority 10)
  dimensionSetEditorEntry,
  // Composite principal picker for `principal` slots (priority 10)
  principalRendererEntry,
  // A formula's value the user may type over (x-computed, mode: default — priority 30): delegates to the field's
  // own renderer, sets the override flag on an edit, offers "reset to calculated"
  computedDefaultRendererEntry,
];

// Re-export individual renderers for direct use
export { lookupRendererEntry } from './LookupRenderer';
export { enumRendererEntry } from './EnumRenderer';
export { dateRendererEntry } from './DateRenderer';
export { dateTimeRendererEntry } from './DateTimeRenderer';
export { conditionEditorRendererEntry } from './ConditionEditorRenderer';
export { triggerEditorRendererEntry } from './TriggerEditorRenderer';
export { actionsEditorRendererEntry } from './ActionsEditorRenderer';
